export default __webpack_public_path__ + "static/media/8.64db4d0c.jpg";